import { Card, Col, Row, Typography } from 'antd';
import { FC } from 'react';
import { Trans } from 'react-i18next';

import Utils from 'utils/utils';

import { OverviewBlockProps } from 'models';

import { Skeleton, Tooltip } from 'componets/ui';

import { ReactComponent as InvestedIcon } from 'assets/icons/48/invested-money.svg';
import { ReactComponent as AnnualReturnIcon } from 'assets/icons/48/anual-return.svg';
import { ReactComponent as AvailableIcon } from 'assets/icons/48/available-money.svg';
import { ReactComponent as InfoIcon } from 'assets/icons/info-grey.svg';

import { useAppSelector, useTranslate } from 'hooks';

import { selectOverview } from 'selectors';

import styles from './index.module.scss';

export const Wallet: FC<OverviewBlockProps> = ({ isLoading }) => {
	const overview = useAppSelector(selectOverview);

	const { availableInvestmentText, investedFundsText, annualReturnText } = useTranslate([
		'availableInvestmentText',
		'investedFundsText',
		'annualReturnText',
	]);

	return (
		<Card bordered={false} className={styles.root}>
			<Skeleton loading={isLoading}>
				<Row gutter={[0, 0]} align="middle">
					<WalletItem
						icon={<AvailableIcon />}
						value={Utils.moneyFormat(Number(overview.availableMoney))}
						label={availableInvestmentText}
					/>

					<WalletItem
						icon={<InvestedIcon />}
						value={Utils.moneyFormat(Number(overview.invested))}
						label={investedFundsText}
					/>

					<WalletItem
						icon={<AnnualReturnIcon />}
						value={`${overview.netAnnualReturn} %`}
						label={
							<span className={styles.row}>
								{annualReturnText}
								<Tooltip
									className="popover"
									title={
										<Trans
											components={{
												link_lt: (
													<a
														className={styles.link}
														href="https://crowdpear.com/lt/duk/kas-yra-metines-grazos-rodiklis"
														target="_blank"
														rel="noreferrer"
													/>
												),
												link_en: (
													<a
														className={styles.link}
														href="https://crowdpear.com/help/what-is-annual-return"
														target="_blank"
														rel="noreferrer"
													/>
												),
											}}
											i18nKey="annualReturnTooltipText"
										/>
									}
								>
									<InfoIcon />
								</Tooltip>
							</span>
						}
					/>
				</Row>
			</Skeleton>
		</Card>
	);
};

type WalletItemProps = {
	icon: JSX.Element;
	label: string | JSX.Element;
	value: string;
};

const WalletItem: FC<WalletItemProps> = ({ icon, label, value }) => {
	return (
		<Col span={24} className={styles.item}>
			<Row align="middle" gutter={[16, 16]}>
				<Col>{icon}</Col>
				<Col>
					<Typography.Text type="secondary" className={styles.label}>
						<Typography.Text className={styles.price}>{value}</Typography.Text>
						{label}
					</Typography.Text>
				</Col>
			</Row>
		</Col>
	);
};
